import {
    abbrNumberVisitsWithNullOrUndefinedFilter,
    percentageSignFilter,
    smallNumbersPercentageFilter,
} from "app/filters/ngFilters";
import { visitsFormatter } from "pro-features/pages/segments/components/benchmarkOvertime/utils";
import {
    ETooltips,
    getTooltipConfigs,
} from "app/pages/app-intelligence/app-analysis/pages/Engagement/config/tooltipBelowTheGraphConfig";
import { chosenItems } from "app/common/services/chosenItems";
import { APPLE_STORE } from "app/pages/app-intelligence/constants";
import { EExportOptions } from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/types";
import { getHasPremiumPlusClaim } from "app/pages/app-intelligence/helpers";

const percentageSignFilterFormatter = (val) => {
    const result = percentageSignFilter()(val, 2);
    return result !== "0.00%" ? result : "<0.01%";
};

const currentInstallsYAxisFilter = (val, decimalPresentation) =>
    !val && val !== 0 ? "N/A" : smallNumbersPercentageFilter()(val, decimalPresentation);

export const getStoreEngagementVerticals = () => {
    const isApple = chosenItems[0]?.AppStore === APPLE_STORE;
    const hasPremiumPlus = getHasPremiumPlusClaim();

    return {
        pageSection: "App Store",
        pageName: "Installs & Downloads",
        meta: [
            {
                title: "apps.engagementoverview.tabs.currentinstalls.title",
                dataKey: "Current Installs", //used in the png service
                name: "CurrentInstalls", //used to get the data as in the api
                icon: "Install",
                filter: (val) => percentageSignFilterFormatter(val),
                yAxisFilter: currentInstallsYAxisFilter,
                tabFilterNum: currentInstallsYAxisFilter,
                isPercentage: true,
                tooltipsArray: [getTooltipConfigs().get(ETooltips.Similar_Algorithm_Change_Date)],
                metric: "AppEngagementCurrentInstalls", //used in the dashboards
                dashboardWidgetType: "AppStoreInstallAndDownloadsOverviewTable",
                infoIcon: "apps.engagementoverview.tabs.currentinstalls.tooltip",
                metricNameForGraphTooltip: "apps.usage.usersengagement.chart.tooltip.percentage",
                decimalPresentationTabTotal: 2,
            },
            {
                title: "apps.engagementoverview.tabs.downloads.title",
                dataKey: "Downloads",
                name: "Downloads",
                icon: "download",
                metricNameForGraphTooltip: "apps.usage.usersengagement.chart.tooltip.amount",
                filter: (val) => visitsFormatter()(val),
                yAxisFilter: abbrNumberVisitsWithNullOrUndefinedFilter(),
                tabFilterNum: abbrNumberVisitsWithNullOrUndefinedFilter(),
                metric: "AppEngagementDownloads",
                dashboardWidgetType: "AppStoreInstallAndDownloadsOverviewTable",
                tooltipsArray: isApple
                    ? [
                          getTooltipConfigs().get(ETooltips.Store_Policy_Change_Date),
                          getTooltipConfigs().get(ETooltips.Similar_Algorithm_Change_Date),
                      ]
                    : [getTooltipConfigs().get(ETooltips.Similar_Algorithm_Change_Date)],
                infoIcon: "apps.engagementoverview.tabs.downloads.tooltip",
            },
            {
                title: hasPremiumPlus
                    ? "app.analysis.storedownloads.storedownloads.title"
                    : "apps.engagementoverview.tabs.unique.installs.title",
                dataKey: "Unique Installs",
                name: "UniqueInstalls",
                metricNameForGraphTooltip: "apps.usage.usersengagement.chart.tooltip.amount",
                icon: "monthly-unique-visitors",
                filter: (val) => visitsFormatter()(val),
                yAxisFilter: abbrNumberVisitsWithNullOrUndefinedFilter(),
                tabFilterNum: abbrNumberVisitsWithNullOrUndefinedFilter(),
                metric: "AppEngagementUniqueInstalls",
                dashboardWidgetType: "AppStoreInstallAndDownloadsOverviewTable",
                infoIcon: "apps.engagementoverview.tabs.unique.installs.tooltip",
                tooltipsArray: [
                    getTooltipConfigs().get(ETooltips.Unique_Install_Start_Date),
                    getTooltipConfigs().get(ETooltips.Similar_Algorithm_Change_Date),
                ],
            },
        ]
            .filter(({ dataKey }) => {
                if (hasPremiumPlus) {
                    return dataKey !== "Downloads";
                }
                return true;
            })
            .map((item) => {
                return {
                    ...item,
                    supportedSharingOptions: [
                        EExportOptions.EXCEL,
                        EExportOptions.WESHARE,
                        EExportOptions.PNG,
                        EExportOptions.DASHBOARD,
                    ],
                };
            }),
        api: {
            overviewTable: "/widgetApi/AppEngagementOverview/AppEngagementStoreOverview/Table",
            overTimeGraph: "/widgetApi/AppEngagementOverview/AppEngagementStoreOverview/Data",
            excelLink: "/widgetApi/AppEngagementOverview/AppEngagementStoreOverview/Excel",
        },
        appleGraphVertical: {
            name: "Downloads",
            title: "apps.store.storeengagement.apple.widget.title",
        },
    };
};
